import { select } from "@fruugo/utilities";

export function hideTooltip(id: string) {
  const tooltip = select(id);
  tooltip?.classList.add("tw:opacity-0", "tw:invisible");
  tooltip?.classList.remove("tw:opacity-100", "tw:visible");
}

export function showTooltip(id: string) {
  const tooltip = select(id);
  tooltip?.classList.add("tw:opacity-100", "tw:visible");
  tooltip?.classList.remove("tw:opacity-0", "tw:invisible");
}

export function toggleTooltip(id: string) {
  const tooltip = select(id);
  const isOpen = tooltip?.classList.contains("tw:visible");
  if (isOpen) {
    hideTooltip(id);
    return;
  }

  showTooltip(id);
}

export const Tooltip = ({ id, text }: { id: string; text: string }) => {
  return (
    <div
      class={`${id} tw:invisible tw:opacity-0 tw:transition-opacity tw:ease-out tw:duration-300`}
    >
      <div
        class="tw:absolute tw:top-full tw:left-1/2 tw:-translate-x-1/2 
                tw:w-0 tw:h-0 
                tw:border-l-10 tw:border-l-transparent
                tw:border-r-10 tw:border-r-transparent
                tw:border-b-10 tw:border-fruugo-black tw:z-10"
      />
      <p class="tw:bg-fruugo-black tw:text-white tw:p-2 tw:rounded tw:m-0 tw:absolute tw:z-20 tw:top-full tw:mt-2 tw:text-center">
        {text}
      </p>
    </div>
  );
};
